{
  "button-bar-for-continue-booking": {
    "button": {
      "cancel": "Cancel",
      "continue": "Continue"
    },
    "text": {
      "continue-booking": "Your booking is not yet complete. Would you like to continue?"
    }
  }
}
